export default __webpack_public_path__ + "fcbf46bcb0e65d9e9944b181fc7ff887.png";